import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30a05808"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "select-address"
}
const _hoisted_2 = { class: "select-address__title h4" }
const _hoisted_3 = { class: "select-address__description" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-arrow-right" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddressField = _resolveComponent("AddressField")!
  const _component_FeedbackDialog = _resolveComponent("FeedbackDialog")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_ctx.pageContent)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.pageContent.title) + " " + _toDisplayString(_ctx.postcode) + "? ", 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.pageContent.subtitle), 1),
        _createVNode(_component_AddressField, {
          address: _ctx.selectedAddress,
          "onUpdate:address": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedAddress) = $event)),
          "first-line-address": _ctx.manualAddressLine1,
          "onUpdate:firstLineAddress": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.manualAddressLine1) = $event)),
          "second-line-address": _ctx.manualAddressLine2,
          "onUpdate:secondLineAddress": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.manualAddressLine2) = $event)),
          class: "customer-address__address-field",
          "input-id": "select-supply-address",
          label: "Supply address",
          placeholder: "Select your supply address",
          loading: _ctx.loading,
          addresses: _ctx.electricityAddresses,
          "address-missing-value": _ctx.addressMissingValue
        }, null, 8, ["address", "first-line-address", "second-line-address", "loading", "addresses", "address-missing-value"]),
        (_ctx.showAddressFetchError)
          ? (_openBlock(), _createBlock(_component_FeedbackDialog, {
              key: 0,
              class: "register__feedback-dialog",
              message: _ctx.pageContent.addressFetchError,
              variant: "negative"
            }, null, 8, ["message"]))
          : _createCommentVNode("", true),
        _createVNode(_component_AppButton, {
          class: "select-address__next-button",
          disabled: _ctx.isAddressProvided,
          "full-width": "",
          onClick: _ctx.submit
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.pageContent.nextButtonCopy), 1),
            _hoisted_4
          ], undefined, true),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]))
    : _createCommentVNode("", true)
}